import Swiper from "swiper"; // 最小限の機能しか入っていない
// import Swiper from 'swiper/bundle'; // 全ての機能が入っている

// import required modules
import { A11y, Autoplay, EffectFade, Navigation, Pagination } from "swiper/modules";

// import Swiper styles
import "swiper/css";
import "swiper/css/effect-fade";
import "swiper/css/navigation";
import "swiper/css/pagination";

Swiper.use([A11y, Autoplay, EffectFade, Navigation, Pagination]);

export default function swiper() {
  const option = {
    a11y: {
      prevSlideMessage: "前のスライド",
      nextSlideMessage: "次のスライド",
    },
    autoplay: {
      delay: 3000,
      disableOnInteraction: false,
    },
    // centeredSlides: true, // アクティブなスライドを中央に配置する
    // freeMode: true,
    lazy: true,
    loop: true,
    speed: 1000,
    // loopAdditionalSlides: 2, // 無限ループさせる場合に複製するスライド数
    navigation: {
      nextEl: ".swiper-button-next",
      prevEl: ".swiper-button-prev",
    },
    pagination: {
      el: ".swiper-pagination",
      clickable: true,
    },
    // slidesPerView: 2, // コンテナ内に表示させるスライド数（CSSでサイズ指定する場合は 'auto'）
    // slidesPerView: 1, // コンテナ内に表示させるスライド数（CSSでサイズ指定する場合は 'auto'）
    // slidesPerView: 1.2, // コンテナ内に表示させるスライド数（CSSでサイズ指定する場合は 'auto'）
    // spaceBetween: 20, // スライド間の余白（px）
    // spaceBetween: 15, // スライド間の余白（px）
  };

  // Remove the unused variable assignment
  new Swiper(".mySwiper", option);
}
